module.exports = require("./fr-LU.d.ts");